'use strict';

var processInclude = require('base:util');

$(document).ready(function () {
    processInclude(require('rxB2C/rxB2C'));
});
